import React from 'react';

import CtaWithHint from 'components/CtaWithHint';
import Hero from 'components/Hero';
import TrustProof from 'components/TrustProof';
import { useI18n } from 'i18n/I18nContext';
import appstore from 'static/images/appstore.png';
import appstore2x from 'static/images/appstore@2x.png';
import hero from 'static/images/hero.png';
import playstore from 'static/images/playstore.png';
import playstore2x from 'static/images/playstore@2x.png';
import tasklist from 'static/images/screenshots/tasklist.png';
import tasklist2x from 'static/images/screenshots/tasklist@2x.png';

const HomeReady = () => {
  const { t, locale } = useI18n();
  const playStoreHref =
    locale === 'nl'
      ? 'https://play.google.com/store/apps/details?id=com.gastrobuddy&hl=nl'
      : 'https://play.google.com/store/apps/details?id=com.gastrobuddy&hl=en';

  return (
    <Hero
      background={hero}
      className="gb-home-ready"
      as="section"
      style={{ backgroundPosition: 'center bottom' }}
    >
      <div className="container gb-home-ready__inner">
        <div className="gb-home-ready__copy gb-hero-content">
          <h2 className="gb-home-ready__title m-0">{t('home.sectionReadyTitle')}</h2>
          <p className="gb-home-ready__body m-0 gb-form-lede">{t('home.sectionReadyBody')}</p>
          <div className="gb-home-ready__cta">
            <CtaWithHint
              href="/onboard"
              buttonLabel={t('home.ctaSecondary')}
              hint={t('home.ctaSecondaryHint')}
              onDark
              trackProps={{ source: 'home_ready' }}
            />
            <TrustProof onDark className="mt-25" />
          </div>
        </div>

        <div className="gb-home-ready__media">
          <img
            className="gb-float-slow gb-home-ready__shot"
            src={tasklist}
            srcSet={`${tasklist2x} 2x`}
            alt={t('home.heroTasklistAlt')}
          />
        </div>
      </div>

      <div className="container gb-home-ready__apps">
        <p className="gb-home-ready__apps-label m-0">{t('home.downloadTitle')}</p>
        <div className="gb-home-ready__stores">
          <a
            className="gb-store-badge"
            href="https://itunes.apple.com/nl/app/gastrobuddy/id1339116265?mt=8"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={appstore} srcSet={`${appstore2x} 2x`} alt="App Store" />
          </a>
          <a
            className="gb-store-badge"
            href={playStoreHref}
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={playstore} srcSet={`${playstore2x} 2x`} alt="Google Play" />
          </a>
        </div>
      </div>
    </Hero>
  );
};

export default HomeReady;



// WEBPACK FOOTER //
// ./src/components/home/HomeReady.tsx